export default "__VITE_ASSET__5qAb38RA__"